<template>
  <div>
    <p class="text-center font-semibold text-lg leading-8">
      Es gelten die vereinbarten und kommunizierten Preise. <br>
      Non-Food Artikel werden separat versendet.
    </p>
    <button
      class="link-button-primary-lg max-w-sm mx-auto mt-8"
      :disabled="!submittable"
      @click.prevent="submitOrder">
      <Spinner
        v-if="submitting"
        class="text-white" />
      Bestellung übermitteln
    </button>
    <div v-if="errorOnSubmit" class="max-w-3xl px-5 py-3 mx-auto bg-red-200 font-semibold text-lg leading-8 bg-200 text-red-800 mt-4">
      <div v-for="(error, index) in errorBag" :key="index">
        <p>{{ error.message }}</p>
        <div v-if="error.extensions.category === 'validation'">
          <ul v-for="(messages, index) in error.extensions.validation" :key="index" class="list-disc list-inside">
            <li v-for="(message, index) in messages" :key="index">{{ message }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ordersStockStore from '@/Store/ordersStock'
import Spinner from '@/Components/Spinner'

export default {
  name: 'OrderSubmit',
  components: { Spinner },
  inject: ['systemStatus'],
  props: {
    submitting: {
      type: Boolean,
      default: false
    },
    errorOnSubmit: {
      type: Boolean,
      default: false
    },
    errorBag: {
      type: Array,
      default: []
    }
  },

  computed: {
    submittable() {
      const result = ordersStockStore.getValidWeekOrders(this.systemStatus.next_order_day)

      return result && result.length > 0
    }
  },

  methods: {
    submitOrder() {
      this.$emit('submit')
    }
  }
}
</script>
